export default __webpack_public_path__ + "static/media/185-1BR.fc231b8b.svg";